import React, { FC, useCallback, useMemo } from "react";
import { FormikProps } from "formik";
import { useTranslation } from "react-i18next";
import { createFieldBlurHandler } from "utils/formValidation";
import { ActionMeta } from "react-select";
import { ExpectedItemsPanelFormValues } from "types/ExpectedForms/ExpectedItemsPanel";
import Input from "../../../../components/Input/Input";
import Select from "../../../../components/Select/Select";
import { FieldWrapper } from "../../../../styles/formStyles";
import { rewriteAssetCdnUrl } from "../../../../utils/assetCdnRewrite";

interface ExpectedParcelFormProps
  extends FormikProps<ExpectedItemsPanelFormValues> {
  shops: any;
}

const ExpectedParcelForm: FC<ExpectedParcelFormProps> = (props) => {
  const {
    setFieldValue,
    values,
    touched,
    errors,
    handleChange,
    shops,
  } = props;
  const handleBlur = createFieldBlurHandler(props);
  const { t } = useTranslation("common");

  const shopOptions = useMemo(
    () =>
      shops
        .map((shop: any) => {
          const name = shop.get("name");
          const thumb = shop.get("thumb_image_url");
          const image =
            (rewriteAssetCdnUrl(thumb) as string) || thumb || undefined;
          return { label: name, value: name, image };
        })
        .sort((a: any, b: any) => a.label.localeCompare(b.label)),
    [shops],
  );

  const handleChangeSelect = useCallback(
    (selectedOption: unknown, context: ActionMeta<unknown>) => {
      if (context.name) {
        setFieldValue(context.name, selectedOption);
      }
    },

    [setFieldValue],
  );

  return (
    <div>
      <FieldWrapper>
        <Input
          placeholder={t("expectedParcel.orderNumber")}
          name="orderNumber"
          value={values.orderNumber}
          onChange={handleChange}
          onBlur={handleBlur}
          tooltip={errors.orderNumber}
          invalid={errors.orderNumber && touched.orderNumber}
        />
      </FieldWrapper>
      <FieldWrapper>
        <Input
          placeholder={t("expectedParcel.trackingNumber")}
          name="trackingNumber"
          value={values.trackingNumber}
          onChange={handleChange}
          onBlur={handleBlur}
          tooltip={errors.trackingNumber}
          invalid={errors.trackingNumber && touched.trackingNumber}
        />
      </FieldWrapper>
      <FieldWrapper>
        <Select
          creatable
          placeholder={`${t("parcels.search.shop")}:`}
          name="storeName"
          value={values.storeName}
          onChange={handleChangeSelect}
          options={shopOptions}
          onBlur={handleBlur}
          tooltip={errors.storeName as string}
          invalid={!!errors.storeName && !!touched.storeName}
          formatCreateLabel={(inputValue: string) => inputValue}
        />
      </FieldWrapper>
      <FieldWrapper>
        <Input
          placeholder={t("expectedParcel.customerComment")}
          name="customerComment"
          value={values.customerComment}
          onChange={handleChange}
          onBlur={handleBlur}
          tooltip={errors.customerComment}
          invalid={errors.customerComment && touched.customerComment}
        />
      </FieldWrapper>
    </div>
  );
};

export default React.memo(ExpectedParcelForm);
